<template>
  <div class="preview-content">
    <div class="authority-tip" v-show="isShowFile"></div>
    <RemoteDocPreview v-if="previewType === 0" :item="fileItem" :user="user"></RemoteDocPreview>
    <LocalDocPreview v-else-if="previewType === 1" :item="fileItem"></LocalDocPreview>
    <template v-else-if="previewType === 2 && nodeList.length">
      <div class="file-body">
        <div class="title">{{ docName }}</div>
        <x-node
          v-for="(node, index) in nodeList.filter(
            item => !(Array.isArray(item.immutableData.hidden) && item.immutableData.hidden.length > 0)
          )"
          :ref="'xnode' + node.nodeId"
          :key="node.nodeId"
          :node="node"
          :nodeIndex="index"
          :playMode="true"
          :fileItem="fileItem"
        ></x-node>
      </div>
      <footer>
        <div class="star">
          <img class="star-img" :src="hasApproved ? pressedStarImage : normalStarImage" @click="handleStar" />
          <div v-if="approveCount !== null">{{ approveCount }}个赞</div>
        </div>
        <div>
          版权声明：您应尊重相关著作人合法权益，未经著作权人合法授权，不能违法上传、存储、分享他人作品
        </div>
        <div>本内容由用户通过<span class="app">MAXHUB文档</span>发布，并不代表视臻公司立场</div>
      </footer>
    </template>
  </div>
</template>

<script>
import LocalDocPreview from './LocalDocPreview/LocalDocPreview';
import RemoteDocPreview from './RemoteDocPreview/RemoteDocPreview';
import Constants from '@constants';
import editorData from '@business/CreateDoc/utils/editor-data';

import XNode from '@business/CreateDoc/XNode/XNode';
import { AIRDISK } from '@services';
import { lazyLoadGetTime } from '@business/CreateDoc/utils/mindeditorUtils';

import normalStarImage from '@assets/images/share/popup_icon_like_normal.svg';
import pressedStarImage from '@assets/images/share/popup_icon_like_pressed.svg';

export default {
  name: 'PreviewContent',
  components: {
    LocalDocPreview,
    RemoteDocPreview,
    XNode
  },
  props: {
    fileItem: {
      type: Object,
      default: () => {}
    },
    user: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isShowFile: true,
      previewType: 1, // 0 表示remotePreview；1 表示本地图片预览；2 表示mhc文件预览
      // filePreviewLoaded: false,
      nodeList: [],
      docName: '',
      normalStarImage,
      pressedStarImage,
      approveCount: null,
      hasApproved: false
    };
  },
  mounted() {
    this.handleShowByContentType();
    AIRDISK.Airdisk.getDocumentApprove(this.fileItem.itemId).then(res => {
      this.approveCount = res.approveCount;
      this.hasApproved = res.hasApproved;
    });
  },
  methods: {
    handleShowByContentType() {
      const contentType = this.fileItem.contentType.toLowerCase();
      if (Constants.Common.DOC_PREVIEW_TYPE.includes(contentType)) {
        this.previewType = 0;
        // 办公套件文件类型 && MHB && MHE：在预览接口中已经自动上报了浏览记录
        // AIRDISK.Airdisk.reportPreview({ fileId: this.fileItem.itemId }).then(() => {});
      } else if (Constants.Common.IMGTYPE.includes(contentType)) {
        this.previewType = 1;
        // 图片文件在本地预览，浏览数据无法上报
        try {
          AIRDISK.Airdisk.reportPreview({ fileId: this.fileItem.itemId })
            .then(() => {})
            .catch(async () => {
              // console.log('上报浏览信息+++');
              await AIRDISK.Airdisk.reportFileDownloadOrShareOrBrowse({
                fileId: this.fileItem.itemId,
                anonymousUser: true,
                type: 2,
                userId: null
              });
            });
        } catch (err) {}
      } else if (contentType === 'mhc') {
        this.previewType = 2;
        const id = this.fileItem.itemId;
        this.handleGetMhcFile(id);
        // AIRDISK.Airdisk.reportPreview({ fileId: id }).then(() => {});
      } else {
        this.previewType = 3;
      }
      // console.log(' this.previewType = ', this.previewType);
    },
    handleStar() {
      if (this.approveCount === null) {
        this.$emit('showLogin');
        return;
      }
      const approve = !this.hasApproved;
      if (this.hasApproved) {
        this.approveCount = this.approveCount - 1;
      } else {
        this.approveCount = this.approveCount + 1;
      }
      this.hasApproved = approve;
      AIRDISK.Airdisk.approveDocument({
        itemId: this.fileItem.itemId,
        approve
      }).catch(() => {
        this.hasApproved = !approve;
        this.approveCount = this.approveCount - 1;
      });
    },
    handleGetMhcFile(id) {
      AIRDISK.Airdisk.getMhcDetail({
        id
      })
        .then(data => {
          this.handleMhcFile(data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getMoreData() {
      window.requestIdleCallback(() => {
        if (document.getElementById(this.nodeList[20].nodeId)) {
          console.log('load');
          editorData.loadData();
          lazyLoadGetTime(this.nodeList);
        } else {
          this.getMoreData(this.nodeList);
        }
      });
    },
    async handleMhcFile(data) {
      console.log({ data });
      const nodeList = data.data.nodeList.map(i => {
        i.data = {
          content: i.content,
          mainBody: i.mainBody
        };
        return i;
      });
      console.log('获取到服务端数据');
      console.time('页面节点渲染耗时');
      console.time('首屏加载时间');
      await editorData.init(nodeList);
      this.nodeList = editorData.toList();
      this.docName = data.data.docName;
      this.getMoreData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './PreviewContent.scss';
</style>
